var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCircleBlueDashRounded = function SvgIconCircleBlueDashRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.467,
    cy: 11.679,
    r: 11.324,
    fill: "#2E5896"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.677,
    cy: 11.679,
    r: 2.058,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.467,
    cy: 11.679,
    r: 2.058,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.258,
    cy: 11.679,
    r: 2.058,
    fill: "#fff"
  })));
};
export { SvgIconCircleBlueDashRounded as ReactComponent };
export default __webpack_public_path__ + "images/Icon_Circle_Blue_Dash_Rounded.svg";